import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../config/axiosConfig";

export const fetchGroupOne = createAsyncThunk(
  "groupOne/fetchGroupOne",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/groups");
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const groupOneSlice = createSlice({
  name: "groupOne",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGroupOne.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGroupOne.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchGroupOne.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default groupOneSlice.reducer;
